import React from 'react'; 
import FadeIn from "react-lazyload-fadein";
import ScrollAnimation from 'react-animate-on-scroll';
import WithConsumer from '../../context/WithConsumer';
import Slider from "react-slick";
import Image from '../global/Image';
import { Link } from 'react-router-dom';
import EnquireButton from './EnquireButton';
import PageFooter from '../page/PageFooter';
import ScrollToTop from '../global/ScrollToTop';

const Project = ({ context }) => {

	let results = '';
		 
    const posts = () => context.posts;
    const post = posts()[0];
	
	const ctxPageLoaded = () => context.pageLoaded;
    const pageLoaded = ctxPageLoaded();
     
    if (post) {
	    
	    let pageClass = 'c-page-wrapper c-page state-not-loaded c-page-' + post.slug;
		if (pageLoaded == true) {
			pageClass = 'c-page-wrapper c-page state-loaded c-page-' + post.slug;
			document.body.style.backgroundColor = '#24272a';
    	}
	        		 
				    
		if (context.appError){
	
			return null; 
			
		} else if (!post.suburb) {
			
			return null;
	
		} else {
			
			const settings = {
				dots: true,
				infinite: true,
				speed: 500,
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplay: true,
				autoplaySpeed: 2400,
			};
			let slides = null;
			let dots = null;
			
			slides = post.gallery.map((image,i) =>
				<div key={i}>
					<Image src={image.src} srcset={image.srcset}></Image>
				</div>
			);
			dots = post.gallery.map((image,i) =>
				<a href="#" key={i}></a>
			);
			
			if (pageLoaded == true) {
				document.body.style.backgroundColor = '#24272a';
			}
				
			return (
				<>
					<ScrollToTop></ScrollToTop>
					<div className={pageClass}>
					
						
						<div className="c-project c-page__block c-page__block--charcoal">
							
							<div className="l-grid c-project__inner">
							
								<div className="l-grid__col l-grid__col--l-6-12 l-grid__col--xl-5-12">
									<header className="c-project__header c-project__header">
										<h1 className="c-heading c-heading--reverse">
											<span className="c-heading__line"><span className="c-heading__line__inner" dangerouslySetInnerHTML={{__html:post.title + '&nbsp;/'}}></span></span>
											<span className="c-heading__line"><span className="c-heading__line__inner" dangerouslySetInnerHTML={{__html:post.suburb}}></span></span>
										</h1>
									</header>								
								</div>
								
								<div className="l-grid__col u-l-hide c-load-fade c-project__meta">
									<EnquireButton title={post.title + ' / ' + post.suburb}></EnquireButton>
									{post.address &&
										<div className="c-row">
											<h5 className="c-paragraph c-paragraph--strong c-paragraph--reverse">Address</h5>
											<p className="c-paragraph c-paragraph--reverse" dangerouslySetInnerHTML={{__html:post.address}}></p>
										</div>
									}
									{post.type &&
										<div className="c-row">
											<h5 className="c-paragraph c-paragraph--strong c-paragraph--reverse">Project Type</h5>
											<p className="c-paragraph c-paragraph--reverse" dangerouslySetInnerHTML={{__html:post.type}}></p>
										</div>
									}
									{post.number_of_homes &&
										<div className="c-row">
											<h5 className="c-paragraph c-paragraph--strong c-paragraph--reverse">Number of Homes</h5>
											<p className="c-paragraph c-paragraph--reverse" dangerouslySetInnerHTML={{__html:post.number_of_homes}}></p>
										</div>
									}
									{post.status &&
										<div className="c-row">
											<h5 className="c-paragraph c-paragraph--strong c-paragraph--reverse">Status</h5>
											<p className="c-paragraph c-paragraph--reverse" dangerouslySetInnerHTML={{__html:post.status}}></p>
										</div>
									}
									{post.buttons &&
										<div className="c-project__buttons">
				    						{post.buttons.map((button,i) =>
												{
													if (button.url.indexOf('http') !== -1) {
														return (
															<a href={button.url} className="c-project__buttons__button" dangerouslySetInnerHTML={{__html:button.text}}></a>
														)
													} else {
														return (
															<Link to={{ pathname: button.url }} className="c-project__buttons__button" dangerouslySetInnerHTML={{__html:button.text}}></Link>
														)
													}
												}
											)}			    						
										</div>
									}
								</div>
								
								<div className="l-grid__col l-grid__col--l-6-12 l-grid__col--xl-push-1-12 c-load-fade c-project__profile">
									<h5 className="c-subheading c-subheading--reverse"><span className="c-subheading__line"><span className="c-subheading__line__inner">Project Profile</span></span></h5>
									{post.profile &&	
										<div className="scope-text scope-text--reverse" dangerouslySetInnerHTML={{__html:post.profile}}></div>
									}
								</div>
								
								<div className="l-grid__col l-grid__col--l-5-12 l-grid__col--xl-4-12 u-l-show c-load-fade c-project__meta">
									<EnquireButton title={post.title + ' / ' + post.suburb}></EnquireButton>
									{post.address &&
										<div className="c-row">
											<h5 className="c-paragraph c-paragraph--strong c-paragraph--reverse">Address</h5>
											<p className="c-paragraph c-paragraph--reverse" dangerouslySetInnerHTML={{__html:post.address}}></p>
										</div>
									}
									{post.type &&
										<div className="c-row">
											<h5 className="c-paragraph c-paragraph--strong c-paragraph--reverse">Type</h5>
											<p className="c-paragraph c-paragraph--reverse" dangerouslySetInnerHTML={{__html:post.type}}></p>
										</div>
									}
									{post.number_of_homes &&
										<div className="c-row">
											<h5 className="c-paragraph c-paragraph--strong c-paragraph--reverse">Number of Homes</h5>
											<p className="c-paragraph c-paragraph--reverse" dangerouslySetInnerHTML={{__html:post.number_of_homes}}></p>
										</div>
									}
									{post.status &&
										<div className="c-row">
											<h5 className="c-paragraph c-paragraph--strong c-paragraph--reverse">Status</h5>
											<p className="c-paragraph c-paragraph--reverse" dangerouslySetInnerHTML={{__html:post.status}}></p>
										</div>
									}
									{post.buttons &&
										<div className="c-project__buttons">
				    						{post.buttons.map((button,i) =>
												{
													if (button.url.indexOf('http') !== -1) {
														return (
															<a href={button.url} className="c-project__buttons__button" dangerouslySetInnerHTML={{__html:button.text}}></a>
														)
													} else {
														return (
															<Link to={{ pathname: button.url }} className="c-project__buttons__button" dangerouslySetInnerHTML={{__html:button.text}}></Link>
														)
													}
												}
											)}			    						
										</div>
									}
								</div>
								
								<div className="l-grid__col l-grid__col--l-6-12 l-grid__col--l-push-1-12 l-grid__col--xl-push-2-12 c-project__gallery">
									<div className={'scope-slick'}>
					    				<Slider {...settings}>
					    					{ slides }
										</Slider>
									</div>
								</div>
		
							</div>
							
						</div>
						
						<Link to={{ pathname: '/projects/' }} className="c-project__link c-load-fade" dangerouslySetInnerHTML={{__html:'Back To Projects'}}></Link>
						
					</div>
					
					<PageFooter post={post}></PageFooter>
				
				</>
				
			)
											
		}

	} else {
		return null;
	}
};
export default WithConsumer(Project);